<template>
  <div class="project-order-settings">
    <!-- Order Status Fields -->
    <b-row class="mb-3">
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('consumablesOrderedState')"
          label-for="consumablesOrderedState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('consumablesOrderedState')"
            v-model="project.consumablesOrderedState"
            :options="yesNo"
            :show-labels="false"
            :allow-empty="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <b-badge :variant="getYesNoStateColor(option)">{{ $t(option) }}</b-badge>
            </template>
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="getYesNoStateColor(option)">
                {{ $t(option) }}
              </b-badge>
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('consumablesInStockState')"
          label-for="consumablesInStockState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('consumablesInStockState')"
            v-model="project.consumablesInStockState"
            :options="yesNo"
            :show-labels="false"
            :allow-empty="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <b-badge :variant="getYesNoStateColor(option)">{{ $t(option) }}</b-badge>
            </template>
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="getYesNoStateColor(option)">
                {{ $t(option) }}
              </b-badge>
            </template>
          </multiselect>
        </b-form-group>
      </b-col>

      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('consumablesDeliveredAt')"
          label-for="consumablesDeliveredAt"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <Calendar
            v-model="consumablesDeliveredAt"
            selectionMode="single"
            dateFormat="dd.mm.yy"
            :placeholder="$t('date')"
            :showWeek="true"
            :yearNavigator="true"
            :monthNavigator="true"
          >
          </Calendar>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('itemPlanningFinishedState')"
          label-for="itemPlanningFinishedState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('itemPlanningFinishedState')"
            v-model="project.itemPlanningFinishedState"
            :options="yesNo"
            :show-labels="false"
            :allow-empty="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <b-badge :variant="getYesNoStateColor(option)">{{ $t(option) }}</b-badge>
            </template>
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="getYesNoStateColor(option)">
                {{ $t(option) }}
              </b-badge>
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { yesNo } from '@/helpers/enums';
import { getYesNoStateColor } from '@/helpers/colors';
import Multiselect from 'vue-multiselect';
import Calendar from 'primevue/calendar';

export default {
  name: 'ProjectOrderSettings',
  components: { Multiselect, Calendar },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    consumablesDeliveredAt: {
      get() {
        return this.$calendarFormat(this.project.consumablesDeliveredAt);
      },
      set(value) {
        this.project.consumablesDeliveredAt = value;
      },
    },
    yesNo,
  },
  methods: {
    getYesNoStateColor,
  },
};
</script>

<style scoped lang="scss"></style>
